/**
 *
 * @module mediaManagerConfiguration
 *
 */

import ServiceConfiguration from './serviceConfiguration';

/**
 *
 * @class MediaManagerConfiguration
 * @desc Provides configuration information necessary for managing media.
 *
 */
export default class MediaManagerConfiguration extends ServiceConfiguration {}



// WEBPACK FOOTER //
// ./src/services/configuration/mediaManagerConfiguration.js